export const getGroupHelper = ({ helperText, error, fields }) => {
  if (helperText) {
    return { helperText, error };
  }

  const fieldWithHelperText = fields.find(field => field.helperText);

  return {
    helperText: fieldWithHelperText?.helperText ?? '',
    error: error || !!fieldWithHelperText?.error,
  };
};

export const getFieldGateProps = ({ group, field }) => ({
  disabled: group.disabled || !!field.disabled,
  error: group.error || !!field.error,
  isFieldChanged: group.isFieldChanged || !!field.isFieldChanged,
  noValidate: group.noValidate || !!field.noValidate,
});
